/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { publicDataRemovalRequestShow } from '../../axios/publicDataRemovalRequestShow'
import type {
	PublicDataRemovalRequestShowError,
	PublicDataRemovalRequestShowPathParams,
	PublicDataRemovalRequestShowResponse,
} from '../../types/PublicDataRemovalRequestShow'

export const publicDataRemovalRequestShowQueryKey = (token: PublicDataRemovalRequestShowPathParams['token']) =>
	[{ url: '/data-removal/:token', params: { token } }] as const

export type PublicDataRemovalRequestShowQueryKey = ReturnType<typeof publicDataRemovalRequestShowQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/PublicDataRemovalRequestController.php PublicDataRemovalRequestController::show */
export function publicDataRemovalRequestShowQueryOptions(
	token: PublicDataRemovalRequestShowPathParams['token'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		PublicDataRemovalRequestShowResponse,
		AxiosError<PublicDataRemovalRequestShowError>,
		PublicDataRemovalRequestShowResponse,
		PublicDataRemovalRequestShowQueryKey
	>({
		queryKey: publicDataRemovalRequestShowQueryKey(token),
		queryFn: ({ signal }) => publicDataRemovalRequestShow(token, { signal, ...config }).then(res => res.data),
		enabled: !!token,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PublicDataRemovalRequestController.php PublicDataRemovalRequestController::show */
export function usePublicDataRemovalRequestShow<TSelectData = PublicDataRemovalRequestShowResponse>(
	token: PublicDataRemovalRequestShowPathParams['token'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					PublicDataRemovalRequestShowResponse,
					AxiosError<PublicDataRemovalRequestShowError>,
					TSelectData,
					PublicDataRemovalRequestShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<PublicDataRemovalRequestShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...publicDataRemovalRequestShowQueryOptions(token),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PublicDataRemovalRequestController.php PublicDataRemovalRequestController::show */
export function usePublicDataRemovalRequestShowSuspense<TSelectData = PublicDataRemovalRequestShowResponse>(
	token: PublicDataRemovalRequestShowPathParams['token'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					PublicDataRemovalRequestShowResponse,
					AxiosError<PublicDataRemovalRequestShowError>,
					TSelectData,
					PublicDataRemovalRequestShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<PublicDataRemovalRequestShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...publicDataRemovalRequestShowQueryOptions(token),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
